import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ACTION_HANDLERS, ActionsModule } from '@fmnts/common/actions';
import {
  DECLARATIVE_FORMS_VALIDATOR_TOKEN,
  GRAPH_NODE_BUILDER_TOKEN,
} from '@fmnts/declarative-forms';
import { provideDeclarativeFormsTaxFeature } from '@fmnts/declarative-forms/tax';

// ==================================================================
// START: Declarative forms
// ==================================================================
import { DonationAmountGraphNodeBuilder } from './donation-amount/donation-amount-node-builder.service';
import { DonationAmountValidationService } from './donation-amount/donation-amount-validation.service';
import { EmailFieldGraphNodeBuilder } from './email/email-node-builder.service';
import { FundraiserGraphNodeBuilder } from './fundraiser/fundraiser-node-builder.service';
import { LocalizationGraphNodeBuilder } from './localization/localization-node-builder.service';
import { LocationGraphNodeBuilder } from './location/location-node-builder.service';
import { PaymentGraphNodeBuilder } from './payment/payment-node-builder.service';
import { PhoneActionHandler } from './phone/phone-action.service';
import { PhoneFieldGraphNodeBuilder } from './phone/phone-node-builder.service';
import { SponsorshipGraphNodeBuilder } from './sponsorship/sponsorship-node-builder.service';

@NgModule({
  imports: [CommonModule, ActionsModule],
  exports: [ActionsModule],
  providers: [
    provideDeclarativeFormsTaxFeature(),
    // ==================================================================
    // Services to inject for `Actions` on next forms
    // ==================================================================
    {
      provide: ACTION_HANDLERS,
      useClass: PhoneActionHandler,
      multi: true,
    },
    // ==================================================================
    // Services to inject for `Validator` on next forms
    // ==================================================================
    {
      provide: DECLARATIVE_FORMS_VALIDATOR_TOKEN,
      useExisting: DonationAmountValidationService,
      multi: true,
    },
    // ==================================================================
    // Services to inject for `FormFieldSource` on next forms
    // ==================================================================
    {
      provide: GRAPH_NODE_BUILDER_TOKEN,
      useExisting: DonationAmountGraphNodeBuilder,
      multi: true,
    },
    {
      provide: GRAPH_NODE_BUILDER_TOKEN,
      useExisting: FundraiserGraphNodeBuilder,
      multi: true,
    },
    {
      provide: GRAPH_NODE_BUILDER_TOKEN,
      useClass: LocalizationGraphNodeBuilder,
      multi: true,
    },
    {
      provide: GRAPH_NODE_BUILDER_TOKEN,
      useExisting: LocationGraphNodeBuilder,
      multi: true,
    },
    {
      provide: GRAPH_NODE_BUILDER_TOKEN,
      useExisting: PaymentGraphNodeBuilder,
      multi: true,
    },
    {
      provide: GRAPH_NODE_BUILDER_TOKEN,
      useClass: PhoneFieldGraphNodeBuilder,
      multi: true,
    },
    {
      provide: GRAPH_NODE_BUILDER_TOKEN,
      useClass: EmailFieldGraphNodeBuilder,
      multi: true,
    },
    {
      provide: GRAPH_NODE_BUILDER_TOKEN,
      useClass: SponsorshipGraphNodeBuilder,
      multi: true,
    },
  ],
})
export class NextFormFeaturesModule {}
